import React, { useEffect, useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Paper,
	TextField,
	Alert,
	Box,
} from "@mui/material";
import "../../../css/empresa_uno/ventas.css";
import pdf from "../../../images/pdf.png";
import buscar_azul from "../../../images/search_azul.png";
import { pdf as PDF } from "@react-pdf/renderer";
import { ApiService } from "../../ApiService";
import { useParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import { GeneratePdfReporteCompras } from "../../../Reports/GeneratePdfReporteCompras";
import Button from "@mui/material/Button";
import { useCompanyAssigned } from "../../CompanyAssignedContext";
import LupaIcon from "../../../svg/lupaIcon";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SearchCompany from "../../../pages/empresa_uno/SearchCompany";

export const VreporteCompras = ({ selectedSucursal, setOption, convertPrice = (() => { }) }) => {
	const { nit, sub_direc } = useParams();

	const [sucursales, setSucursales] = useState([]);
	const [objReports, setObjReports] = useState([]);
	const [fechaIni, setFechaIni] = useState(null);
	const [fechaFin, setFechaFin] = useState(null);

	const getDatosCompras = async (key_branch, fecha1, fecha2) => {
		const url = `api/company/purchase/reports?start_date=${fecha1}&end_date=${fecha2}&key_branch=${key_branch}`;
		const options = { method: "GET" };
		const request_totals = await ApiService.fetchData(url, options);
		if (!request_totals) {
			alert("Error al cargar los datos de compras del día");
			return;
		}

		setObjReports(request_totals);
	};
	const formatDate = (dateString) => {
		if (!dateString) return "";

		const date = new Date(dateString);
		if (isNaN(date.getTime())) return dateString;

		const day = String(date.getDate()).padStart(2, "0");
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const year = date.getFullYear();

		return `${day}/${month}/${year}`;
	};

	const generateReporteCompras = async () => {
		const url = `api/company/purchase/pdf-reports?key_branch=${selectedSucursal}&start_date=${fechaIni}&end_date=${fechaFin}`;
		const options = { method: "GET" };
		const request_totals = await ApiService.fetchData(url, options);
		if (request_totals !== null) {
			const MyDoc = (
				<GeneratePdfReporteCompras
					pdfData={request_totals}
					fechaIni={formatDate(fechaIni)}
					fechaFin={formatDate(fechaFin)}
					themeColor={'var(--theme-company)'}
					convertPrice={convertPrice}
				/>
			);
			const asPdf = PDF(MyDoc);
			const blob = await asPdf.toBlob();
			const fileURL = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = fileURL;
			link.download = `Reporte_Compras.pdf`;
			link.click();
			URL.revokeObjectURL(fileURL);
		}
	};


	useEffect(() => {
		const current_suc = selectedSucursal;
		const comp_date = new Date();
		const currentDate = `${comp_date.getFullYear()}-${String(comp_date.getMonth() + 1).padStart(2, "0")}-${String(comp_date.getDate()).padStart(2, "0")}`;

		if (fechaIni == null && fechaFin == null) {
			setFechaFin(currentDate);
			setFechaIni(currentDate);
		}

		setSucursales(current_suc);
		getDatosCompras(current_suc, fechaIni || currentDate, fechaFin || currentDate);
	}, [selectedSucursal]);

	function handleChange(e, comp) {
		comp === 1 ? setFechaIni(e) : setFechaFin(e);

		getDatosCompras(sucursales, comp === 1 ? e : fechaIni, comp === 2 ? e : fechaFin);
	}
	// Datos estáticos de la tabla
	const totales = {
		cantidad: objReports?.reduce((acc, venta) => acc + venta.qp, 0),
		costo: objReports?.reduce((acc, venta) => (parseFloat(venta.purchase_price) + parseFloat(acc)).toFixed(2), 0),
		beneficio: objReports?.reduce(
			(acc, venta) => (parseFloat(acc) + (parseFloat(venta.price) - parseFloat(venta.purchase_price))).toFixed(2),
			0
		),
		precio: objReports?.reduce((acc, venta) => (parseFloat(acc) + parseFloat(venta.price)).toFixed(2), 0),
	};
	return (
		<div>
			<div className="functionality-container">
				<div className="header-reports">
					<h2 style={{ color: 'var(--theme-company)' }}>Reporte de Compras</h2>

					<div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
						<TextField
							label="Fecha Inicial"
							type="date"
							value={fechaIni}
							onChange={(e) => handleChange(e.target.value, 1)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>

						<TextField
							label="Fecha Fin"
							type="date"
							value={fechaFin}
							onChange={(e) => handleChange(e.target.value, 2)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</div>

					<div>
						<SearchCompany theme={'var(--theme-company)'} placeholder="reporte de compra" />

						<div>
							<Button variant="contained" style={{ background: 'var(--theme-company)' }} onClick={generateReporteCompras} startIcon={<PictureAsPdfIcon />}>
								<span style={{ color: '#fff' }}>PDF</span>
							</Button>
						</div>
					</div>
				</div>
			</div>

			<TableContainer component={Paper}>
				<Table>
					<TableHead>
						<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
							{["FECHA", "CODIGO", "PRODUCTO", "CANTIDAD", "PRECIO COMPRA", "DESCUENTO"].map(
								(header, index) => (
									<TableCell
										key={index}
										sx={{
											color: "white",
											fontWeight: "bold",
											textAlign: "center",
											fontSize: "0.9rem",
										}}>
										{header}
									</TableCell>
								)
							)}
						</TableRow>
					</TableHead>

					<TableBody>
						{objReports?.map((report, idx) => (
							<TableRow key={`${report.id} ${idx}`}>
								<TableCell align="center">{report.date_ope}</TableCell>
								<TableCell align="center">{report.code}</TableCell>
								<TableCell align="center">{report.product_name}</TableCell>
								<TableCell align="center">{report.qp}</TableCell>
								<TableCell align="center">{convertPrice(report.purchase_price, null, true)}</TableCell>
								<TableCell align="center">{convertPrice(report.discount_price, null, true)}</TableCell>
							</TableRow>
						))}
					</TableBody>

					<TableFooter>
						<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
							<TableCell align="center" colSpan={3} sx={{ color: "white", fontWeight: "bold" }}>
								TOTAL
							</TableCell>
							<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
								{totales.cantidad}
							</TableCell>
							<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
								{convertPrice(totales.costo)}
							</TableCell>
							<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
								{convertPrice(objReports?.reduce(
									(acc, item) => (parseFloat(acc) + parseFloat(item.discount_price || 0)),
									0
								))}
							</TableCell>
						</TableRow>
					</TableFooter>
				</Table>
			</TableContainer>
		</div>
	);
};
